import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AddBucketMemberTrigger from './addBucketMembers/AddBucketMembersTrigger';
import AddBucketMembersContent from './addBucketMembers/AddBucketMembersContent';

import * as bucketSelectors from '../../selectors/bucketSelectors';

const AddBucketMembers = ({ isAddMember }) => {
    if (isAddMember) {
        return <AddBucketMembersContent />;
    }

    return <AddBucketMemberTrigger />;
};

AddBucketMembers.propTypes = {
    isAddMember: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    isAddMember: bucketSelectors.isAddMember(state),
});

export default connect(mapStateToProps)(AddBucketMembers);



// WEBPACK FOOTER //
// ./src/containers/bucketMembers/AddBucketMembers.js